import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";

import Lead from "../../../shared/Lead";
import AudioControl from "./AudioControl";

const PhoneCallButton = ({ phoneNumber }) => {
  return(
    <>
      <a
        style={{verticalAlign: 'super'}}
        onClick={(e) => {
          if (phoneNumber == 'wellPORTAL') { return
          };
          window.document.getElementById('dial-pad-widget-btn').click();
          setTimeout((e) => {
            window.document.getElementById('dial-widget-phone-number-field').value = phoneNumber;
          }, 1000);
      }}>
        {phoneNumber}
      </a>
    </>
  );
}

export default PhoneCallButton;
